export default
{
  "warmup": {
    "id": "warmup",
    "name": "5 Min. Warmup",
    "images": [
      "/assets/exercise-photos/warmup.jpg"
    ]
  },
  "home-warmup": {
    "id": "home-warmup",
    "name": "5 Min. Warmup",
    "images": [
      "/assets/exercise-photos/jumping-jack.jpg"
    ]
  },
  "stretch": {
    "id": "stretch",
    "name": "Stretch",
    "images": [
      "/assets/exercise-photos/stretch.jpg"
    ]
  },
  "dumbbell-bench-press": {
    "id": "dumbbell-bench-press",
    "name": "Dumbbell Bench Press",
    "images": [
      "/assets/exercise-photos/dumbbell-bench-press.jpg"
    ]
  },
  "chest-press-machine": {
    "id": "chest-press-machine",
    "name": "Chest Press Machine",
    "images": [
      "/assets/exercise-photos/chest-press-machine.jpg"
    ]
  },
  "incline-dumbbell-bench-press": {
    "id": "incline-dumbbell-bench-press",
    "name": "Incline Dumbbell Bench Press",
    "images": [
      "/assets/exercise-photos/incline-dumbbell-bench-press.jpg"
    ]
  },
  "incline-dumbbell-fly": {
    "id": "incline-dumbbell-fly",
    "name": "Incline Dumbbell Fly",
    "images": [
      "/assets/exercise-photos/incline-dumbbell-fly.jpg"
    ]
  },
  "cable-crossover": {
    "id": "cable-crossover",
    "name": "Cable Crossover",
    "images": [
      "/assets/exercise-photos/cable-crossover.jpg"
    ]
  },
  "straight-bar-cable-curl": {
    "id": "straight-bar-cable-curl",
    "name": "Straight Bar Cable Curl",
    "images": [
      "/assets/exercise-photos/straight-bar-cable-curl.jpg"
    ]
  },
  "dip-machine": {
    "id": "dip-machine",
    "name": "Dip Machine",
    "images": [
      "/assets/exercise-photos/dip-machine.jpg"
    ]
  },
  "cable-tricep-pressdown": {
    "id": "cable-tricep-pressdown",
    "name": "Cable Tricep Pressdown",
    "images": [
      "/assets/exercise-photos/cable-tricep-pressdown.jpg"
    ]
  },
  "overhead-tricep-extension": {
    "id": "overhead-tricep-extension",
    "name": "Overhead Tricep Extension",
    "images": [
      "/assets/exercise-photos/overhead-tricep-extension.jpg"
    ]
  },
  "calf-raise": {
    "id": "calf-raise",
    "name": "Calf Raise",
    "images": [
      "/assets/exercise-photos/calf-raise2.jpg"
    ]
  },
  "home-calf-raise": {
    "id": "home-calf-raise",
    "name": "Calf Raise",
    "images": [
      "/assets/exercise-photos/dumbbell-calf-raise.jpg"
    ]
  },
  "wide-grip-pullup": {
    "id": "wide-grip-pullup",
    "name": "Wide Grip Pullup",
    "images": [
      "/assets/exercise-photos/wide-grip-pullup.jpg"
    ]
  },
  "dumbbell-bent-over-row": {
    "id": "dumbbell-bent-over-row",
    "name": "Dumbbell Bent-Over Row",
    "images": [
      "/assets/exercise-photos/dumbbell-bent-over-row.jpg"
    ]
  },
  "standing-pulldown": {
    "id": "standing-pulldown",
    "name": "Standing Pulldown",
    "images": [
      "/assets/exercise-photos/standing-pulldown.jpg"
    ]
  },
  "straight-arm-pulldown": {
    "id": "straight-arm-pulldown",
    "name": "Straight Arm Pulldown'",
    "images": [
      "/assets/exercise-photos/straight-arm-pulldown.jpg"
    ]
  },
  "face-pull": {
    "id": "face-pull",
    "name": "Face Pull",
    "images": [
      "/assets/exercise-photos/face-pull.jpg"
    ]
  },
  "incline-dumbbell-curl": {
    "id": "incline-dumbbell-curl",
    "name": "Incline Dumbbell Curl",
    "images": [
      "/assets/exercise-photos/incline-dumbbell-curl.jpg"
    ]
  },
  "overhead-cable-curl": {
    "id": "overhead-cable-curl",
    "name": "Overhead Cable Curl",
    "images": [
      "/assets/exercise-photos/overhead-cable-curl.jpg"
    ]
  },
  "abs": {
    "id": "abs",
    "name": "Abs - TBD"
  },
  "dumbbell-shoulder-press": {
    "id": "dumbbell-shoulder-press",
    "name": "Dumbbell Shoulder Press",
    "images": [
      "/assets/exercise-photos/dumbbell-shoulder-press.jpg"
    ]
  },
  "dumbbell-lateral-raise": {
    "id": "dumbbell-lateral-raise",
    "name": "Dumbbell Lateral Raise",
    "images": [
      "/assets/exercise-photos/dumbbell-lateral-raise.jpg"
    ]
  },
  "dumbbell-front-raise": {
    "id": "dumbbell-front-raise",
    "name": "Dumbbell Front Raise",
    "images": [
      "/assets/exercise-photos/dumbbell-front-raise.jpg"
    ]
  },
  "high-cable-rear-delt-fly": {
    "id": "high-cable-rear-delt-fly",
    "name": "High Cable Rear Delt Fly",
    "images": [
      "/assets/exercise-photos/high-cable-rear-delt-fly.jpg"
    ]
  },
  "dumbbell-shrug": {
    "id": "dumbbell-shrug",
    "name": "Dumbbell Shrug",
    "images": [
      "/assets/exercise-photos/dumbbell-shrug.jpg"
    ]
  },
  "dumbbell-front-squat": {
    "id": "dumbbell-front-squat",
    "name": "Dumbbell Front Squat",
    "images": [
      "/assets/exercise-photos/dumbbell-front-squat.jpg"
    ]
  },
  "goblet-squat": {
    "id": "goblet-squat",
    "name": "Goblet Squat",
    "images": [
      "/assets/exercise-photos/goblet-squat.jpg"
    ]
  },
  "dumbbell-lunge": {
    "id": "dumbbell-lunge",
    "name": "Dumbbell Lunge",
    "images": [
      "/assets/exercise-photos/dumbbell-lunge.jpg"
    ]
  },
  "leg-press-machine": {
    "id": "leg-press-machine",
    "name": "Leg Press Machine",
    "images": [
      "/assets/exercise-photos/leg-press-machine.jpg"
    ]
  },
  "leg-extension": {
    "id": "leg-extension",
    "name": "Leg Extension",
    "images": [
      "/assets/exercise-photos/leg-extension.jpg"
    ]
  },
  "leg-curl": {
    "id": "leg-curl",
    "name": "Leg Curl",
    "images": [
      "/assets/exercise-photos/leg-curl.jpg"
    ]
  },
  "romanian-deadlift": {
    "id": "romanian-deadlift",
    "name": "Romanian Deadlift",
    "images": [
      "/assets/exercise-photos/romanian-deadlift.jpg"
    ]
  },
  "low-cable-chest-fly": {
    "id": "low-cable-chest-fly",
    "name": "Low Cable Chest Fly",
    "images": [
      "/assets/exercise-photos/low-cable-chest-fly.jpg"
    ]
  },
  "incline-dumbbell-fly-chest-fly-machine": {
    "id": "incline-dumbbell-fly-chest-fly-machine",
    "name": "Incline Dumbbell Fly or Chest Fly Machine",
    "images": [
      "/assets/exercise-photos/incline-dumbbell-fly.jpg"
    ]
  },
  "tricep-rope-pressdown-overhead-extension": {
    "id": "tricep-rope-pressdown-overhead-extension",
    "name": "Tricep Rope Pressdown or Overhead Extension",
    "images": [
      "/assets/exercise-photos/tricep-rope-pressdown.jpg"
    ]
  },
  "ab-machine": {
    "id": "ab-machine",
    "name": "Abdominal Machine",
    "images": [
      "/assets/exercise-photos/ab-machine.jpg"
    ]
  },
  "lying-leg-raise": {
    "id": "lying-leg-raise",
    "name": "Lying Ab Leg Raise",
    "images": [
      "/assets/exercise-photos/lying-leg-raise.jpg"
    ]
  },
  "hanging-leg-raise": {
    "id": "hanging-leg-raise",
    "name": "Hanging Leg Raise",
    "images": [
      "/assets/exercise-photos/lying-leg-raise.jpg"
    ]
  },
  "russian-twist": {
    "id": "russian-twist",
    "name": "Russian Twist",
    "images": [
      "/assets/exercise-photos/russian-twist.jpg"
    ]
  },
  "plank": {
    "id": "plank",
    "name": "Plank",
    "images": [
      "/assets/exercise-photos/plank.jpg"
    ]
  },
  "spiderman-plank": {
    "id": "spiderman-plank",
    "name": "Spiderman Plank",
    "images": [
      "/assets/exercise-photos/spiderman-plank.jpg"
    ]
  },
  "side-plank": {
    "id": "side-plank",
    "name": "Side Plank",
    "images": [
      "/assets/exercise-photos/side-plank.jpg"
    ]
  },
  "dumbbell-curl": {
    "id": "dumbbell-curl",
    "name": "Dumbbell Curl",
    "images": [
      "/assets/exercise-photos/dumbbell-curl.jpg"
    ]
  },
  "dumbbell-hammer-curl": {
    "id": "dumbbell-hammer-curl",
    "name": "Dumbbell Hammer Curl",
    "images": [
      "/assets/exercise-photos/dumbbell-hammer-curl.jpg"
    ]
  },
  "seated-cable-row": {
    "id": "seated-cable-row",
    "name": "Seated Cable Row",
    "images": [
      "/assets/exercise-photos/seated-cable-row.jpg"
    ]
  },
  "seated-back-machine": {
    "id": "seated-back-machine",
    "name": "Seated Back Machine",
    "images": [
      "/assets/exercise-photos/seated-back-machine.jpg"
    ]
  },
  "wide-grip-lateral-pulldown": {
    "id": "wide-grip-lateral-pulldown",
    "name": "Wide Grip Lateral Pulldown",
    "images": [
      "/assets/exercise-photos/wide-grip-lateral-pulldown.jpg"
    ]
  },
  "barbell-curl": {
    "id": "barbell-curl",
    "name": "Barbell Curl",
    "images": [
      "/assets/exercise-photos/barbell-curl.jpg"
    ]
  },
  "reverse-barbell-curl": {
    "id": "reverse-barbell-curl",
    "name": "Reverse Barbell Curl",
    "images": [
      "/assets/exercise-photos/reverse-barbell-curl.jpg"
    ]
  },
  "shoulder-press-machine": {
    "id": "shoulder-press-machine",
    "name": "Shoulder Press Machine",
    "images": [
      "/assets/exercise-photos/shoulder-press-machine.jpg"
    ]
  },
  "reverse-machine-fly": {
    "id": "reverse-machine-fly",
    "name": "Reverse Machine Fly",
    "images": [
      "/assets/exercise-photos/reverse-machine-fly.jpg"
    ]
  },
  "reverse-dumbbell-fly": {
    "id": "reverse-dumbbell-fly",
    "name": "Reverse Dumbbell Fly",
    "images": [
      "/assets/exercise-photos/reverse-dumbbell-fly.jpg"
    ]
  },
  "hanging-leg-raise": {
    "id": "hanging-leg-raise",
    "name": "Hanging leg Raise",
    "images": [
      "/assets/exercise-photos/hanging-leg-raise.jpg"
    ]
  },
  "bicycle-crunch": {
    "id": "bicycle-crunch",
    "name": "Bicycle Crunch",
    "images": [
      "/assets/exercise-photos/bicycle-crunch.jpg"
    ]
  },
  "standard-pushup": {
    "id": "standard-pushup",
    "name": "Pushup",
    "images": [
      "/assets/exercise-photos/standard-pushup.jpg"
    ]
  },
  "decline-pushup": {
    "id": "decline-pushup",
    "name": "Decline Pushup",
    "images": [
      "/assets/exercise-photos/decline-pushup.jpg"
    ]
  },
  "incline-pushup": {
    "id": "incline-pushup",
    "name": "Incline Pushup",
    "images": [
      "/assets/exercise-photos/incline-pushup.jpg"
    ]
  },
  "chair-dip": {
    "id": "chair-dip",
    "name": "Chair Dip",
    "images": [
      "/assets/exercise-photos/chair-dip.jpg"
    ]
  },
  "underhand-pullup": {
    "id": "underhand-pullup",
    "name": "Underhand Pullup",
    "images": [
      "/assets/exercise-photos/underhand-pullup.jpg"
    ]
  },
  "resistance-band-curl": {
    "id": "resistance-band-curl",
    "name": "Resistance Band Curl",
    "images": [
      "/assets/exercise-photos/resistance-band-curl.jpg"
    ]
  },
  "lower-back-curl": {
    "id": "lower-back-curl",
    "name": "Lower Back Curl",
    "images": [
      "/assets/exercise-photos/lower-back-curl.jpg"
    ]
  },
  "resistance-band-lateral-raise": {
    "id": "resistance-band-lateral-raise",
    "name": "Resistance Band Lateral Raise",
    "images": [
      "/assets/exercise-photos/resistance-band-lateral-raise.jpg"
    ]
  },
  "air-squat": {
    "id": "air-squat",
    "name": "Air Squat",
    "images": [
      "/assets/exercise-photos/air-squat.jpg"
    ]
  },
  "bodyweight-lunge": {
    "id": "bodyweight-lunge",
    "name": "Lunge",
    "images": [
      "/assets/exercise-photos/bodyweight-lunge.jpg"
    ]
  },
  "lunge-to-high-knee": {
    "id": "lunge-to-high-knee",
    "name": "Lunge to High Knee",
    "images": [
      "/assets/exercise-photos/high-knees.jpg"
    ]
  },
  "glute-bridge": {
    "id": "glute-bridge",
    "name": "Glute Bridge",
    "images": [
      "/assets/exercise-photos/glute-bridge.jpg"
    ]
  },
  "donkey-kick": {
    "id": "donkey-kick",
    "name": "Donkey Kick",
    "images": [
      "/assets/exercise-photos/donkey-kick.jpg"
    ]
  },
  "wall-sit": {
    "id": "wall-sit",
    "name": "Wall Sit",
    "images": [
      "/assets/exercise-photos/wall-sit.jpg"
    ]
  },
  "high-knees": {
    "id": "high-knees",
    "name": "High Knees",
    "images": [
      "/assets/exercise-photos/high-knees.jpg"
    ]
  },
  "bent-over-resistance-band-row": {
    "id": "bent-over-resistance-band-row",
    "name": "Resistance Band Bent Over Row",
    "images": [
      "/assets/exercise-photos/bent-over-resistance-band-row.jpg"
    ]
  },
  "overhead-dumbbell-extension": {
    "id": "overhead-dumbbell-extension",
    "name": "Overhead Dumbbell Extension",
    "images": [
      "/assets/exercise-photos/overhead-dumbbell-extension.jpg"
    ]
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/providers/exercises/exercise-list.js
// module id = 254
// module chunks = 6